import script from "./DaPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./DaPermissions.vue?vue&type=script&setup=true&lang=js"

import "./DaPermissions.vue?vue&type=style&index=0&id=7065066a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7065066a"]])

export default __exports__